import { Link } from "react-router-dom";
import { Badge } from "./ui/badge";
import { Bike, ArrowRight } from "lucide-react";

export function BikeCard({ bike }) {
  return (
    <Link
      to={`/bikes/${bike.id}`}
      data-testid={`bike-card-${bike.id}`}
      className="group block border border-border rounded-xl overflow-hidden bg-white hover:-translate-y-1 hover:shadow-lg transition-all duration-300"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-secondary">
        <img src={bike.image} alt={bike.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        <Badge className="absolute top-3 left-3 bg-white text-foreground capitalize hover:bg-white">{bike.type}</Badge>
        {!bike.available && (
          <Badge className="absolute top-3 right-3 bg-destructive text-white hover:bg-destructive">Unavailable</Badge>
        )}
      </div>
      <div className="p-5">
        <div className="flex items-center gap-2 text-muted-foreground text-sm">
          <Bike className="w-4 h-4" /> {bike.engine}
        </div>
        <h3 className="mt-1 text-lg font-bold tracking-tight">{bike.name}</h3>
        <div className="mt-4 flex items-end justify-between">
          <div>
            <p className="text-2xl font-black font-display text-primary">£{bike.weekly_rate}<span className="text-sm text-muted-foreground font-medium">/week</span></p>
            <p className="text-xs text-muted-foreground mt-0.5">or £{bike.monthly_rate}/month</p>
          </div>
          <span className="grid place-items-center w-9 h-9 rounded-full bg-primary text-white group-hover:scale-110 transition-transform">
            <ArrowRight className="w-4 h-4" />
          </span>
        </div>
      </div>
    </Link>
  );
}
